var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLonger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1869_50239)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5303 9.03033C11.2374 9.32322 10.7626 9.32322 10.4697 9.03033C10.1768 8.73744 10.1768 8.26256 10.4697 7.96967L13.4697 4.96967C13.7626 4.67678 14.2374 4.67678 14.5303 4.96967L17.5303 7.96967C17.8232 8.26256 17.8232 8.73744 17.5303 9.03033C17.2374 9.32322 16.7626 9.32322 16.4697 9.03033L14.75 7.31066V13.25H22.5C22.9142 13.25 23.25 13.5858 23.25 14C23.25 14.4142 22.9142 14.75 22.5 14.75H14.75V20.6893L16.4697 18.9697C16.7626 18.6768 17.2374 18.6768 17.5303 18.9697C17.8232 19.2626 17.8232 19.7374 17.5303 20.0303L14.5303 23.0303C14.2374 23.3232 13.7626 23.3232 13.4697 23.0303L10.4697 20.0303C10.1768 19.7374 10.1768 19.2626 10.4697 18.9697C10.7626 18.6768 11.2374 18.6768 11.5303 18.9697L13.25 20.6893V14.75H5.5C5.08579 14.75 4.75 14.4142 4.75 14C4.75 13.5858 5.08579 13.25 5.5 13.25H13.25V7.31066L11.5303 9.03033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1869_50239",
    x: 3.75,
    y: 4.75,
    width: 20.5,
    height: 20.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1869_50239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1869_50239",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLonger);
export default __webpack_public_path__ + "static/media/ic-longer.b2d11ffd9fbd1f3354ff2b58f2989bcf.svg";
export { ForwardRef as ReactComponent };